import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokanyakumari() {



  const cardData =
  {
    keyword: 'Pune to Kanyakumari Bus Tour Package',
    heading: 'Sanavi Travels: Pune to Kanyakumari Bus Tour Package',
    headingDescription: 'Sanavi Travels offers Pune to Kanyakumari Bus Tour Package, providing safe, comfortable, and well-planned transportation for families, groups, pilgrims, and sightseeing travelers exploring South India. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a relaxing journey. With experienced drivers, customized tour itineraries, transparent pricing, and 24/7 booking support, the Pune to Kanyakumari bus tour package guarantees punctual, reliable, and stress-free travel. Choose Sanavi Travels for a trusted Pune to Kanyakumari bus tour, combining comfort, safety, and convenience for a memorable travel experience.',

    top: 'Top Places to Visit in Kanyakumari with Sanavi Travels',


"topPlaces": [
  {
    "title": "Kanyakumari Town",
    "description": "Kanyakumari is India’s southernmost coastal town, located at the confluence of the Arabian Sea, Bay of Bengal, and the Indian Ocean. Known for its spiritual aura, breathtaking ocean views, and cultural richness, Kanyakumari has been a sacred pilgrimage center since ancient times. The town is famous for its spectacular sunrises and sunsets, drawing pilgrims, poets, photographers, and travelers from across the world."
  },
  {
    "title": "Kanyakumari Amman Temple",
    "description": "The Kanyakumari Amman Temple is dedicated to Goddess Parvati in her virgin (Kanya) form. One of the Shakti Peethas, the temple holds immense spiritual significance in Hindu tradition. Devotees believe that worshipping here brings purity, strength, and divine protection. The temple is especially revered for its sacred history, ancient rituals, and powerful spiritual vibrations."
  },
  {
    "title": "Vivekananda Rock Memorial",
    "description": "Vivekananda Rock Memorial is situated on a small rocky island off the Kanyakumari coast. It marks the spot where Swami Vivekananda meditated in deep contemplation. The memorial symbolizes spiritual awakening and national pride, offering a peaceful atmosphere and panoramic views of the surrounding seas."
  },
  {
    "title": "Thiruvalluvar Statue",
    "description": "Standing tall near the Vivekananda Rock, the Thiruvalluvar Statue honors the great Tamil poet and philosopher Thiruvalluvar. The statue represents wisdom, virtue, and moral values described in the Tirukkural. It is an architectural marvel and a cultural symbol of Tamil heritage."
  },
  {
    "title": "Triveni Sangam",
    "description": "The Triveni Sangam at Kanyakumari is the sacred meeting point of three seas. Pilgrims perform holy rituals and take ceremonial dips, believing the waters cleanse sins and grant spiritual merit. The natural color variations of the seas make this site visually stunning and spiritually powerful."
  },
  {
    "title": "Gandhi Memorial Mandapam",
    "description": "The Gandhi Memorial was built at the spot where Mahatma Gandhi’s ashes were kept before immersion. On Mahatma Gandhi’s birthday, sunlight falls directly on the place where the urn was kept. The memorial reflects simplicity, peace, and India’s freedom movement legacy."
  },
  {
    "title": "Sunrise and Sunset Viewpoints",
    "description": "Kanyakumari is one of the rare places in India where both sunrise and sunset can be witnessed over the ocean. These moments are considered spiritually uplifting and visually mesmerizing, attracting visitors early in the morning and at dusk."
  },
  {
    "title": "Our Lady of Ransom Church",
    "description": "This beautiful white church near the seashore reflects Kanyakumari’s religious harmony. Built in Gothic style, it attracts Christian pilgrims and tourists alike. The peaceful ambiance and coastal location enhance its charm."
  },
  {
    "title": "Suchindram Thanumalayan Temple (Nearby)",
    "description": "Located near Kanyakumari, this ancient temple is dedicated to the trinity Brahma, Vishnu, and Shiva. Known for its musical pillars, towering gopuram, and intricate sculptures, it is an important spiritual and architectural landmark."
  },
  {
    "title": "Cultural and Spiritual Significance",
    "description": "Kanyakumari represents a unique blend of spirituality, history, culture, and natural beauty. From ancient legends and freedom movement history to poetic sunrises and ocean vistas, the town offers a deeply enriching experience for pilgrims, historians, and travelers alike."
  }
]
,



"services": [
{
"name": "Pune to Kanyakumari Bus Tour Package",
"description": "Pune to Kanyakumari Bus Tour Package offers a well-planned and comfortable long-distance tour experience for travelers exploring the southernmost destination of India. Ideal for families, tourists, and group travelers, this package includes well-maintained buses, spacious seating, and smooth interstate travel. With experienced drivers and organized routes, passengers can enjoy a safe, relaxed, and memorable journey from Pune to Kanyakumari."
},
{
"name": "Kanyakumari Bus Hire from Pune",
"description": "Kanyakumari Bus Hire from Pune provides reliable and organized bus rental services for long-distance South India tours. Designed for group travel, this service ensures punctual departures, professional chauffeurs, and comfortable buses, making extended journeys stress-free and well-managed."
},
{
"name": "AC Bus Pune to Kanyakumari",
"description": "AC Bus Pune to Kanyakumari ensures a pleasant and refreshing travel experience with fully air-conditioned buses. Perfect for long-distance journeys, summer travel, and family vacations, these buses offer relaxed seating, smooth suspension, and climate-controlled comfort throughout the tour."
},
{
"name": "Luxury South India Tour Bus",
"description": "Luxury South India Tour Bus delivers a premium travel experience with modern interiors, pushback seats, and enhanced onboard amenities. Ideal for corporate groups, senior travelers, and luxury tour seekers, this service combines comfort, safety, and style for an enjoyable South India tour."
},
{
"name": "Family Kanyakumari Trip",
"description": "Family Kanyakumari Trip bus services are designed to provide safe, comfortable, and organized travel for families of all sizes. Spacious seating, smooth driving, and reliable scheduling ensure a pleasant tour experience for children, adults, and senior citizens alike."
},
{
"name": "Group Travel Kanyakumari Bus",
"description": "Group Travel Kanyakumari Bus offers efficient transportation for friends, tour groups, educational trips, and organizations. High-capacity buses, experienced chauffeurs, and well-coordinated travel plans ensure safe, comfortable, and smooth group journeys."
},
{
"name": "Affordable Kanyakumari Tour Package",
"description": "Affordable Kanyakumari Tour Package provides cost-effective travel solutions without compromising on comfort or safety. Ideal for budget-conscious travelers and group tours, this package includes reliable buses, transparent pricing, and professional drivers for economical long-distance travel."
},
{
"name": "Chauffeur Driven Tour Bus",
"description": "Chauffeur Driven Tour Bus ensures a hassle-free travel experience with skilled drivers handling highways, interstate routes, and long-distance schedules. This service emphasizes passenger safety, punctuality, and smooth driving for relaxed and worry-free tour travel."
},
{
"name": "Best Kanyakumari Bus Package Pune",
"description": "Best Kanyakumari Bus Package Pune is known for quality service, comfortable buses, and customer satisfaction. Suitable for family tours, group travel, and holiday trips, it focuses on comfort, safety standards, and well-organized itineraries."
},
{
"name": "Pune Kanyakumari Travel Bus",
"description": "Pune Kanyakumari Travel Bus offers organized and dependable bus travel for tourists heading to Kanyakumari. With comfortable seating, experienced drivers, and planned routes, this service ensures a smooth and enjoyable long-distance journey."
},
{
"name": "Tourist Bus South India",
"description": "Tourist Bus South India caters to travelers exploring popular destinations across South India, including Tamil Nadu and Kerala. Flexible itineraries, comfortable buses, and professional drivers make sightseeing and holiday travel convenient and enjoyable."
},
{
"name": "Long Distance Bus Tour",
"description": "Long Distance Bus Tour services provide reliable transportation for extended interstate journeys. Designed for comfort and safety, these buses include spacious seating, trained drivers, and proper rest planning to ensure smooth and fatigue-free long-distance travel."
},
{
"name": "Online Bus Booking Pune",
"description": "Online Bus Booking Pune allows travelers to easily reserve buses for Kanyakumari and South India tours with quick confirmation. Multiple bus options, simple booking steps, and dependable service make holiday planning efficient and hassle-free."
},
{
"name": "Tamil Nadu Bus Tour",
"description": "Tamil Nadu Bus Tour offers organized bus travel for exploring famous destinations across Tamil Nadu, including Kanyakumari. With experienced chauffeurs, comfortable buses, and well-planned itineraries, this service ensures a culturally rich and comfortable travel experience."
},
{
"name": "Holiday Bus Package",
"description": "Holiday Bus Package provides complete bus tour solutions for long vacations and leisure travel. Ideal for families, groups, and tour organizers, this service focuses on comfort, safety, and reliable scheduling to deliver a relaxing and memorable holiday journey."
}
],
"tableData": [
["Pune to Kanyakumari Bus Tour Package", "Kanyakumari Bus Hire from Pune"],
["AC Bus Pune to Kanyakumari", "Luxury South India Tour Bus"],
["Family Kanyakumari Trip", "Group Travel Kanyakumari Bus"],
["Affordable Kanyakumari Tour Package", "Chauffeur Driven Tour Bus"],
["Best Kanyakumari Bus Package Pune", "Pune Kanyakumari Travel Bus"],
["Tourist Bus South India", "Long Distance Bus Tour"],
["Online Bus Booking Pune", "Tamil Nadu Bus Tour"],
["Holiday Bus Package", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Kanyakumari Bus Tour Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers a well-planned and comfortable Pune to Kanyakumari bus tour package, ideal for group tours, family vacations, pilgrimages, and long-distance sightseeing journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, spacious, air-conditioned, and regularly maintained to ensure a relaxed and enjoyable long-distance journey from Pune to Kanyakumari."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our professional and licensed drivers are experienced in long-route travel, ensuring safe, smooth, and timely journeys across multiple states."
  },
  {
    "WhyChooseheading": "All-Inclusive Transparent Pricing",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Kanyakumari bus tour packages, including fuel, tolls, driver allowance, and taxes with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary customization, and on-trip assistance throughout your Pune to Kanyakumari tour."
  },
  {
    "WhyChooseheading": "Customizable Tour Itineraries",
    "WhyChoosedescription": "We offer flexible and customizable tour plans allowing you to include sightseeing spots, temple visits, and rest halts as per your group’s preference."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before departure to ensure a safe and hygienic travel experience for every passenger."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "With punctual departures and dependable service, Sanavi Travels is a trusted choice for long-distance bus tour packages like Pune to Kanyakumari."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Pune to Kanyakumari bus tour packages?',
    answer: 'Yes, Sanavi Travels provides complete Pune to Kanyakumari bus tour packages for group travel, sightseeing, and pilgrimage.'
  },
  {
    question: 'How can I book a Pune to Kanyakumari bus tour?',
    answer: 'You can book the tour package through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for the Kanyakumari tour?',
    answer: 'We offer mini buses, 20-seater, 32-seater, 45-seater, and 50-seater buses based on your group size and comfort needs.'
  },
  {
    question: 'Can the tour itinerary be customized?',
    answer: 'Yes, the Pune to Kanyakumari bus tour itinerary can be customized with sightseeing spots, temple visits, and rest breaks.'
  },
  {
    question: 'Are the drivers experienced with long-distance tours?',
    answer: 'Absolutely. Our drivers are highly experienced in long-distance and multi-state travel routes.'
  },
  {
    question: 'Is customer support available during the tour?',
    answer: 'Yes, our 24x7 customer support team remains available throughout your Pune to Kanyakumari journey.'
  },
  {
    question: 'Are buses sanitized before the tour starts?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every tour for passenger safety.'
  },
  {
    question: 'What payment options are available for booking?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is this tour suitable for families and senior citizens?',
    answer: 'Yes, the Pune to Kanyakumari bus tour package is suitable for families, senior citizens, and group travelers.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Kulkarni',
    feedback: 'Our Pune to Kanyakumari bus tour with Sanavi Travels was extremely comfortable and well-organized. Excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Joshi',
    feedback: 'Sanavi Travels made our long journey smooth and memorable. Clean bus, polite driver, and great coordination.',
    rating: 5
  }
];
















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Kanyakumari Bus Tour Package - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to Kanyakumari bus tour packages with AC and luxury buses. Perfect for South India sightseeing, family trips, and group travel. Affordable, chauffeur-driven buses with online booking available.",
  "touristType": "Family Trip, Group Travel, Holiday Tour, Long Distance Travel, South India Sightseeing",
  "departureLocation": "Pune",
  "arrivalLocation": "Kanyakumari, Tamil Nadu",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "30"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Pune to Kanyakumari Bus Tour Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Kanyakumari bus tour packages by Sanavi Travels. AC and luxury buses for family trips, group travel, South India sightseeing. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/198.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokanyakumari;